module.exports = __webpack_public_path__ + "img/cloth_g1_sleeve_06.69d09034.svg";